function excerpts(text: string = '', limit: number, moreSymbol: string): string {
  return text.length < limit && text ||
  `${text.substr( 0,  limit)}${moreSymbol}`;
}

export default excerpts;